import type {JSX} from 'react';
import {BrowserRouter} from 'react-router-dom';
import {WorkspaceProvider} from './workspace/WorkspaceContext';
import {WorkspaceShell} from './components/WorkspaceShell';
import './App.css';

export default function App(): JSX.Element {
  return <BrowserRouter><WorkspaceProvider><WorkspaceShell/></WorkspaceProvider></BrowserRouter>;
}